import { useQuery } from '@tanstack/react-query';
import { useBffClient } from './client';
import type { DashboardOverview } from '../types/dashboard';

export function useDashboardOverview(daysBack = 30) {
  const client = useBffClient();
  return useQuery({
    queryKey: ['dashboard', 'overview', daysBack],
    queryFn: () =>
      client.get<DashboardOverview>(`/bff/dashboard/overview?daysBack=${daysBack}`),
  });
}
